import { render, staticRenderFns } from "./ListeningPhonics2Form.vue?vue&type=template&id=549e8508&"
import script from "./ListeningPhonics2Form.vue?vue&type=script&lang=js&"
export * from "./ListeningPhonics2Form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports